import React from "react";
import "./index.less";

interface IProps {
  isShared: boolean;
  size?: string;
  imgUrl?: string;
}
const ShareIcon = (props: IProps) => {
  // console.log(props, 'propspropsprops');
  const { isShared = false, size = "12px", imgUrl } = props;
  return (
    <span className="joyspace-share-icon">
      {imgUrl ? (
        <img src={imgUrl} />
      ) : (
        <span
          data-icon
          data-category
          className={isShared ? " joyspace-data-category-share_icon" : ""}
        />
      )}
    </span>
  );
};

export default ShareIcon;
